"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsStatusMessages = void 0;
var react_1 = __importDefault(require("react"));
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
/**
 * Stacked error + success MessageBars rendered above the editable content.
 */
exports.SettingsStatusMessages = function (props) {
    var errorMessage = props.errorMessage, successMessage = props.successMessage;
    if (!errorMessage && !successMessage) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        errorMessage && (react_1.default.createElement("div", { className: "ws-ai-hub-settings-status" },
            react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error }, errorMessage))),
        successMessage && (react_1.default.createElement("div", { className: "ws-ai-hub-settings-status" },
            react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.success }, successMessage)))));
};
